import { render, staticRenderFns } from "./CreateClashRoyaleTournament.vue?vue&type=template&id=6ec7a4b1&lang=pug"
import script from "./CreateClashRoyaleTournament.vue?vue&type=script&lang=js"
export * from "./CreateClashRoyaleTournament.vue?vue&type=script&lang=js"
import style0 from "./CreateClashRoyaleTournament.vue?vue&type=style&index=0&id=6ec7a4b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports